import {createFileRoute} from '@tanstack/react-router';

import DiagnosticReportSent from '@/patient/views/DiagnosticReportSent';
import DiagnosticReportSentClinicalTrial from '@/patient/views/DiagnosticReportSent/DiagnosticReportSentClinicalTrial';
import {useCompany} from '@/shared/contexts/UserContext/useUserContext';

function DiagnosticReportSentRoute() {
  const {isForClinicalTrials} = useCompany();

  return isForClinicalTrials ? <DiagnosticReportSentClinicalTrial /> : <DiagnosticReportSent />;
}

export const Route = createFileRoute('/(patient)/patient/diagnostic-report-sent')({
  component: DiagnosticReportSentRoute
});
